import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response } from '../types'

export interface Vendor {
  id: number
  name: string
  mobile: string
  address: string
  address2?: string
  email?: string
  gstin?: string
  pan?: string
  state?: string
  stateCode?: string
  pincode?: string
  place?: string
  profileUrl?: string | null
  registrationType?: string
  isDeleted?: boolean
}

export interface FetchVendorsResponse extends Response {
  data: Vendor[]
}

export interface GetVendorByIdResponse extends Response {
  data: Vendor
}

export interface DeleteVendorAPIResponse extends Response {
  data: null
}

export type AddVendorRequest = {
  id?: number
  name: string
  mobile: string
  address: string
  address2?: string
  email?: string
  gstin?: string
  pan?: string
  state?: string
  stateCode?: string
  pincode?: string
  place?: string
  profileUrl?: string | null
  registrationType?: string
}

export interface AddVendorResponse extends Response {
  data: Vendor
}

export const addVendor = (request: AddVendorRequest) => {
  return http
    .post<AddVendorRequest>('/vendor/pvt', request)
    .then((response: AxiosResponse) => response)
}

export function getVendorsList() {
  return http.get('/vendor/pvt').then((response: AxiosResponse) => response)
}

export function getVendorById(id: number) {
  return http
    .get<GetVendorByIdResponse>(`/vendor/pvt/${id}`)
    .then((response: AxiosResponse) => response)
}

export const deleteVendor = (id: number) => {
  return http
    .delete(`/vendor/pvt/${id}`)
    .then((response: AxiosResponse) => response)
}
